import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SignInForm from '../SignInForm/SignInForm';
import useStyles from './SignInModal.styles';
const SignInModal = (props) => {
    const { classes } = useStyles();
    const { onSignIn, saveUserJourneyAnalytics } = props;
    return (_jsxs("div", { className: classes.box, children: [_jsx("div", { className: classes.signInHeader, children: _jsxs("div", { className: classes.signInInnerContainer, children: [_jsx("h2", { children: "Sign in" }), _jsx("p", { children: "If you\u2019re already registered" })] }) }), _jsx("div", { className: classes.signInForm, children: _jsx("div", { className: classes.signInInnerContainer, children: _jsx(SignInForm, { onSubmit: onSignIn, saveUserJourneyAnalytics: saveUserJourneyAnalytics }) }) })] }));
};
export default SignInModal;
